// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageLoader_wrapper__2XSAQ"};